module.exports = __webpack_public_path__ + "static/media/19ESCAP31.4e284a92.jpg";